import { runInAction } from "mobx";
import { observer } from "mobx-react-lite";

import Latex from "../../internal/latex";
import { IButtonControl } from "../../types/control";
import { useStore } from "../hooks";

interface ButtonControlProps {
  control: IButtonControl;
}

export const ButtonControl = observer<ButtonControlProps>(({ control }) => {
  const context = useStore();
  const computationStore = context?.computationStore;

  // Guard: computationStore must be available
  if (!computationStore) {
    return <div className="text-red-500">No computation store available</div>;
  }
  const { variable, code, label } = control;

  const handleClick = () => {
    if (code) {
      try {
        // Execute code in a MobX action for proper reactivity
        runInAction(() => {
          // Create value accessor with just the values (same as manual engine)
          const vars: Record<string, any> = {};
          computationStore.variables.forEach((variable, key) => {
            if (variable && variable.value !== undefined) {
              vars[key] = variable.value;
            }
          });

          // Execute the function
          code(vars);

          // Sync back all modified variables
          for (const [key, value] of Object.entries(vars)) {
            const variable = computationStore.variables.get(key);
            if (
              variable &&
              (Array.isArray(value) || typeof value === "number")
            ) {
              variable.value = value;
            }
          }

          computationStore.runComputation();
        });
      } catch (error) {
        console.error("Error executing button code:", error);
      }
    }
  };

  return (
    <>
      {variable && (
        <div className="mb-3">
          <Latex latex={variable} />
        </div>
      )}
      <button
        onClick={handleClick}
        className="nodrag px-4 py-2 bg-gradient-to-b from-white to-gray-100 hover:from-gray-100 hover:to-gray-200 text-gray-800 rounded-xl transition-all border border-slate-300"
      >
        {label || "Click"}
      </button>
    </>
  );
});

export default ButtonControl;
